import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import UltimatePagination from 'react-ultimate-pagination-bootstrap-3';

import TitleBar from 'components/title_bar';
import LoadingSpinner from 'components/loading_spinner';
import AggregateView from 'components/importer/aggregate_view';
import ImportRequestsTable from './table/import_requests_table';

import { retrieveImportRequests } from '../../store/actions/search';
import { changeImportRequestPage } from '../../store/actions/query';
import { getImportRequests, isFetching } from '../../store/selectors/search';
import { getAggregateView } from '../../store/selectors/static';
import { getCurrentPage, getTodalPages } from '../../store/selectors/search';

export function ImportRequestsList({
  aggregateView,
  currentPage,
  importRequests,
  isFetching,
  onPageChange,
  retrieveRecords,
  totalPages
}) {
  useEffect(() => {
    !aggregateView && retrieveRecords();
  }, []);

  const handlePageChange = (page) => {
    onPageChange(page);
    retrieveRecords();
  };

  const renderEmptyState = () => (
    <div className="panel-body text-center" name="empty-state">
      <h4 className="text-muted mb-4">
        No client import requests were found for the current database.
      </h4>
    </div>
  );

  const renderResults = () => {
    if (isFetching) {
      return <LoadingSpinner/>;
    } else if (importRequests.length > 0) {
      return <ImportRequestsTable importRequests={importRequests} />;
    }
    return renderEmptyState();
  };

  const renderPagination = () => {
    if (isFetching || totalPages <= 1)  {
      return null;
    }

    return (
      <div className="text-center">
        <UltimatePagination
          currentPage={currentPage}
          totalPages={totalPages}
          onChange={handlePageChange}
        />
      </div>
    );
  };

  const renderBody = () => {
    if (aggregateView) {
      return <AggregateView/>;
    }
    return renderResults();
  };

  return (
    <React.Fragment>
      <TitleBar
        subtitle="Review and complete client import requests"
        title="Import Requests"
      />

      <div className="container white">
        {renderBody()}
        {renderPagination()}
      </div>
    </React.Fragment>
  );
}

ImportRequestsList.propTypes = {
  aggregateView: PropTypes.bool.isRequired,
  currentPage: PropTypes.number.isRequired,
  importRequests: PropTypes.array.isRequired,
  isFetching: PropTypes.bool.isRequired,
  retrieveRecords: PropTypes.func.isRequired,
  totalPages: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  aggregateView: getAggregateView(state),
  currentPage: getCurrentPage(state),
  importRequests: getImportRequests(state),
  isFetching: isFetching(state),
  totalPages: getTodalPages(state)
});

const mapDispatchToProps = {
  onPageChange: changeImportRequestPage,
  retrieveRecords: retrieveImportRequests
};

export default connect(mapStateToProps, mapDispatchToProps)(ImportRequestsList);
